<script>
    let {
        className = "",
        headerText,
        returnBtn = false,
        actionBack,
        textBtn,
        onClickButton,
        section,
        toast,
    } = $props();

    import { getMobileOS } from "@/utils/common";
    import { GradientBkg, Header, Toast } from "@/components";
</script>

<Header text={headerText} {returnBtn} {actionBack} />
{#if section}
    <section class="{className} section {getMobileOS()}">
        {@render section()}
        {#if textBtn}
            <button class="--fixedBtn" onclick={onClickButton}>{textBtn}</button
            >
        {/if}
    </section>
{/if}

{#if toast}
    <Toast {...toast} />
{/if}

<style lang="scss">
    @use "./styles/index.scss";
</style>
